import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {SurfaceContextMenuProvider} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/area/contextMenu/SurfaceAreaContextMenuProvider';
import {ContextMenu} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SurfaceAreaContextMenu.less');
const cx = classnames.bind(styles);

interface SurfaceAreaContextMenuProps
{
    className?:string;
}

@observer
export class SurfaceAreaContextMenu extends React.Component<SurfaceAreaContextMenuProps, any>
{
    private _lastActiveElement:HTMLElement = null;

    private _handleMouseDownCapture = (e:React.MouseEvent<any>) =>
    {
        if( e.button === 2 && e.shiftKey )
            e.stopPropagation();
    };

    render()
    {
        const {surfaceArea} = controllers.ui;
        const {className} = this.props;

        const dataSource = surfaceArea.isInPreviewOrZenPreviewMode()
            ? null
            : SurfaceContextMenuProvider.contextMenuProvider;

        return (
            <div
                className={cx('base', {[className]: !!className})}
                onMouseDownCapture={this._handleMouseDownCapture}
            >
                <ContextMenu
                    className={cx('menu')}
                    contentClassName={cx('menuContent')}
                    dataSource={dataSource}
                    useMousePositionAsPopupSource={true}
                    onShow={() => this._lastActiveElement = document.activeElement as HTMLElement}
                    onHide={() =>
                    {
                        if( this._lastActiveElement )
                            this._lastActiveElement.focus();
                    }}
                >
                    {this.props.children}
                </ContextMenu>
            </div>
        );
    }
}
